module.exports = __webpack_public_path__ + "assets/img/17_1087_big.0bfa9d28.jpg";